import { Component } from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';

@Component({
  selector: 'app-navigation-secondary-local-jobs',
  template: `
    <app-bar
      i18n-title="Secondary navigation local jobs bar title"
      title="Local Jobs"
      link="/local"
      flTrackingSection="SubnavLocalJobs"
    >
      <app-bar-item link="/local"
        [exactLink]="true"
        i18n="Secondary navigation local jobs bar item"
        flTrackingLabel="PostALocalJob"
      >
        Post a Local Job
      </app-bar-item>
      <app-bar-item link="/local/browse"
        i18n="Secondary navigation local jobs bar item"
        flTrackingLabel="BrowseLocalJobs"
      >
        Browse Local Jobs
      </app-bar-item>
      <fl-button
        [color]="ButtonColor.PRIMARY"
        link="/post-project"
        [queryParams]="{ skill_category: 9 }"
        i18n="Secondary navigation local jobs bar post project button"
        flTrackingLabel="PostProjectButton"
      >
        Post a Local Job
      </fl-button>
    </app-bar>
  `,
})
export class NavigationSecondaryLocalJobsComponent {
  ButtonColor = ButtonColor;
}
